import React, { useState } from 'react';
import { Button, Box, Snackbar, Alert } from '@mui/material';
import { useBooking } from '../context/BookingContext';

function BookingToggle() {
  const { isBookingActive, toggleBookingStatus } = useBooking();
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const handleToggle = async () => {
    const newStatus = !isBookingActive;
    const success = await toggleBookingStatus(newStatus);
    if (success) {
      setSnackbar({
        open: true,
        message: `Booking ${newStatus ? 'activated' : 'deactivated'}`,
        severity: 'success'
      });
    } else {
      setSnackbar({
        open: true,
        message: 'Failed to update booking status',
        severity: 'error'
      });
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  return (
    <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
      <Button
        variant="contained"
        color={isBookingActive ? 'error' : 'success'}
        onClick={handleToggle}
        size="small"
        sx={{ 
          minWidth: 120,
          whiteSpace: 'nowrap',
          textTransform: 'none',
          fontWeight: 500,
          py: 0.5,
          px: 1.5,
          fontSize: '0.8rem'
        }}
      >
        {isBookingActive ? 'Deactivate Booking' : 'Activate Booking'}
      </Button>
      <Box sx={{ 
        fontSize: '0.85rem', 
        color: isBookingActive ? 'success.main' : 'text.secondary',
        fontWeight: 500
      }}>
        {isBookingActive ? 'Booking is active' : 'Booking is inactive'}
      </Box>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ fontSize: '0.9rem' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default BookingToggle;
